/**
 * Root layout with bottom navigation
 */
import { Outlet } from 'react-router-dom';
import { BottomNav } from '@/shared/ui';
import { BarChart3, List, Tag, Link2, GitCompare } from 'lucide-react';

const NAV_ITEMS = [
  {
    path: '/brands',
    label: 'Brands',
    icon: <Tag size={20} strokeWidth={2} />,
    activeIcon: <Tag size={20} strokeWidth={3} />,
  },
  {
    path: '/events',
    label: 'Events',
    icon: <List size={20} strokeWidth={2} />,
    activeIcon: <List size={20} strokeWidth={3} />,
  },
  {
    path: '/stats',
    label: 'Stats',
    icon: <BarChart3 size={20} strokeWidth={2} />,
    activeIcon: <BarChart3 size={20} strokeWidth={3} />,
  },
  {
    path: '/compare',
    label: 'Compare',
    icon: <GitCompare size={20} strokeWidth={2} />,
    activeIcon: <GitCompare size={20} strokeWidth={3} />,
  },
  {
    path: '/links',
    label: 'Links',
    icon: <Link2 size={20} strokeWidth={2} />,
    activeIcon: <Link2 size={20} strokeWidth={3} />,
  },
];

export function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col px-4 pt-2 pb-24 max-w-lg mx-auto bg-[var(--tg-theme-bg-color)]">
      <div className="flex-1">
        <Outlet />
      </div>
      <BottomNav items={NAV_ITEMS} />
    </div>
  );
}
